import { ObjectType } from '$app-web/types';
import { EDFError, FatalError } from '$app-web/utils';

import { hasObjectKeys } from '../object';

export class ModuleURLsManager {
    spaceId: string;

    moduleId: string;

    subModules: Record<string, { baseUrl: string; URLs: ObjectType<string> }> = {};

    URLs: Record<string, string> = {};

    constructor(spaceId: string, moduleId: string) {
        this.spaceId = spaceId;
        this.moduleId = moduleId;
    }

    inModule(): boolean {
        const parsedPath = new URL(window.location.href);
        return parsedPath.pathname.includes(this.moduleId);
    }

    addSubModule(subModuleId: string, baseUrl: string, URLs: Record<string, string>) {
        if (!hasObjectKeys(this.subModules, subModuleId)) {
            this.subModules[subModuleId] = { baseUrl, URLs };
        } else {
            throw new FatalError(
                `Trying to sub module which exists.`,
                new EDFError(`Sub module with Id: ${subModuleId} already exists.`)
            );
        }
    }

    setURLs(URLs: Record<string, string>) {
        this.URLs = { ...this.URLs, ...URLs };
    }

    replaceParamsInLink(url: string, params: ObjectType<string | number>) {
        const paramsKeys = Object.keys(params);

        return paramsKeys.reduce((finalURL, key) => finalURL.replace(`:${key}`, `${params[key]}`), url);
    }

    to(id: string, params: ObjectType<string | number> = {}, includeModulePath = true, subModuleId = '') {
        if (hasObjectKeys(this.subModules, subModuleId) || hasObjectKeys(this.URLs, id)) {
            const matchedModule = this.subModules[subModuleId];
            return this.replaceParamsInLink(
                `/${this.spaceId}${includeModulePath ? `/${this.moduleId}` : ''}${
                    matchedModule != null ? `/${matchedModule.baseUrl}` : ''
                }${matchedModule != null ? matchedModule.URLs[id] : this.URLs[id]}`,
                params
            );
        }
        throw new FatalError(`Trying to get url to not existing path. Path ${id} doesn't exist.`);
    }
}
